import { CardHeader, CardHeaderTitle } from 'components/card/card-header';
import { CardBody, CardFooter } from 'components/card';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import Modal from 'components/modal/Modal';
import { useContext } from 'react';
import { StoreContext } from 'index';
import { ROUTE_SUPPORT } from 'routes/RouteList';
import LinkAsButton from 'components/link/Link';
import {
  COOKIE_POLICY_URL,
  PRIVACY_POLICY_URL,
  SUPPORT_EMAIL,
  SUPPORT_URL,
  TERMS_OF_SERVICE_URL
} from 'constants.js';

const SupportModal = ({ onClose }) => {
  const {
    authStore: { user, entity }
  } = useContext(StoreContext);
  const onCloseHandler = () => {
    if (onClose) onClose();
  };

  const supportUrl = entity?.info?.support?.url
    ? entity.info.support.url.startsWith('https://')
      ? entity.info.support.url
      : `https://${entity.info.support.url}`
    : SUPPORT_URL;

  const supportEmail = entity?.info?.support?.email ?? SUPPORT_EMAIL;

  return (
    <Modal cardSmall autoHeight isOpen={true} onClose={onCloseHandler}>
      <CardHeader modal>
        <CardHeaderTitle>
          <FormattedMessage {...messages.modalSupportTitle} />
        </CardHeaderTitle>
      </CardHeader>
      <CardBody modal>
        <FormattedMessage
          {...messages.modalSupportMessage}
          values={{
            p: chunks => <p>{chunks}</p>,
            helpLink: chunks => (
              <LinkAsButton
                inline
                external
                to={{ pathname: supportUrl ?? ROUTE_SUPPORT }}
              >
                {chunks}
              </LinkAsButton>
            ),
            email: supportEmail,
            emailLink: chunks => (
              <LinkAsButton
                inline
                external
                mail
                to={{ pathname: `mailto:${chunks}` }}
              >
                {chunks}
              </LinkAsButton>
            )
          }}
        />

        {!user.isHanOrg && (
          <div
            className="o-flex o-flex--wrap o-flex--justify-center
         u-margin-top-medium u-margin-bottom-tiny"
            style={{ gap: '4px 16px' }}
          >
            <LinkAsButton
              external
              inline
              secondary
              to={{
                pathname: PRIVACY_POLICY_URL
              }}
            >
              <FormattedMessage {...messages.supportPrivacyStatementLink} />
            </LinkAsButton>
            <LinkAsButton
              external
              inline
              secondary
              to={{
                pathname: TERMS_OF_SERVICE_URL
              }}
            >
              <FormattedMessage {...messages.supportTermsOfServiceLink} />
            </LinkAsButton>
            <LinkAsButton
              external
              inline
              secondary
              to={{
                pathname: COOKIE_POLICY_URL
              }}
            >
              <FormattedMessage {...messages.supportCoockiePolicyLink} />
            </LinkAsButton>
          </div>
        )}
      </CardBody>
      <CardFooter modal></CardFooter>
    </Modal>
  );
};

export default SupportModal;
